/**
 * sessionVocabulary (Wave 2 item 5) — location values a rep CREATED this
 * session through FieldComboSheet's `Use "…"` row, keyed by fieldKey.
 *
 * MODULE-LEVEL, NOT COMPONENT STATE. FieldRecordModal remounts its editors per
 * record, so anything held in React state would vanish the moment the rep
 * moved to the next tool — exactly when a just-typed "Bay 7" is most needed.
 * A module Map lives as long as the page does.
 *
 * NOT PERSISTED. Nothing here is written to IndexedDB. A created value is
 * committed to the record like any other edit; once saved it is on the
 * record's row, and the next Load hands it to getFieldUniqueValues, which is
 * the durable source. This Map only bridges the gap until then.
 *
 * ⚠ Keyed by fieldKey ONLY — not by site. A value created at one site is
 * offered at every site for the rest of the session.
 */

const vocab = new Map(); // fieldKey → string[] (first-seen casing, insertion order)

const fold = (s) => String(s).toLowerCase();

/** Values created this session for one field, as a fresh array. */
export function getSessionValues(fieldKey) {
  return [...(vocab.get(fieldKey) || [])];
}

/**
 * Remember one created value. Case-insensitive de-dupe: the first casing a
 * rep typed wins, a later "BAY 7" does not add a second "Bay 7". Empty or
 * whitespace-only values are ignored.
 */
export function addSessionValue(fieldKey, value) {
  if (!fieldKey) return;
  const s = String(value ?? '').trim();
  if (s === '') return;
  const list = vocab.get(fieldKey) || [];
  if (!list.some((v) => fold(v) === fold(s))) {
    vocab.set(fieldKey, [...list, s]);
  }
}

/** Test seam: forget everything. Never called by app code. */
export function clearSessionVocabulary() {
  vocab.clear();
}
